/* 流程审批 */
const layoutComponent = () => import('@/views/layout')

export default [{
  path: '/processApprovalManagement',
  component: layoutComponent,
  meta: {
    title: 'menu.processApprovalManagement',
    icon: 'el-icon-ali-ProcessApprovalManagement'
  },
  children: [
    // {
    //   path: '/processApprovalManagement/processApprovalCompanyView',
    //   name: 'processApprovalCompanyView',
    //   component: () => import('@/views/processApprovalManagement/processApprovalCompanyView.vue'),
    //   meta: {
    //     title: 'menu.ApprovalCompanyProces'
    //   }
    // },
    // {
    //   path: '/processApprovalManagement/processApprovalProjectView',
    //   name: 'processApprovalProjectView',
    //   component: () => import('@/views/processApprovalManagement/processApprovalProjectView.vue'),
    //   meta: {
    //     title: 'menu.ApprovalProjectProcess'
    //   }
    // }
    // 公司审核
    {
      path: '/companyManagement/CompanyProcessAudit',
      name: 'companyProcessAudit',
      component: () => import('@/views/companyprocessaudit/index.vue'),
      meta: {
        title: 'menu.companyProcessAuditList',
        buttons: [{
            code: 'scan',
            name: '浏览'
          },
          {
            code: 'approve',
            name: '审核'
          },
          {
            code: 'view',
            name: '查看'
          },
        ]
      }
    },
    {
      path: '/companyManagement/CompanyProcessAudit/Audit',
      name: 'companyProcessDoAudit',
      component: () => import('@/views/companyprocessaudit/audit.vue'),
      meta: {
        title: 'menu.auditCompanyProcess',
        routeNameParent: 'companyProcessAudit'
      }
    },
    {
      path: '/companyManagement/CompanyProcessAudit/View',
      name: 'companyProcessAuditView',
      component: () => import('@/views/companyprocessaudit/view.vue'),
      meta: {
        title: 'menu.viewCompanyProcessAudit',
        routeNameParent: 'companyProcessAudit'
      }
    },
    // 项目流程审核
    {
      path: '/projectManagement/projectProcessAudit',
      name: 'projectProcessAudit',
      component: () => import('@/views/projectProcessAudit/index.vue'),
      meta: {
        title: 'menu.projectProcessAuditList',
        buttons: [{
            code: 'scan',
            name: '浏览'
          },
          {
            code: 'approve',
            name: '审核'
          },
          {
            code: 'view',
            name: '查看'
          },
        ]
      }
    },
    {
      path: '/projectManagement/projectProcessAudit/Audit',
      name: 'projectProcessDoAudit',
      component: () => import('@/views/projectProcessAudit/audit.vue'),
      meta: {
        title: 'menu.auditProjectProcess',
        routeNameParent: 'projectProcessAudit'
      }
    },
    {
      path: '/projectManagement/projectProcessAudit/View',
      name: 'projectProcessAuditView',
      component: () => import('@/views/projectProcessAudit/view.vue'),
      meta: {
        title: 'menu.viewProjectProcessAudit',
        routeNameParent: 'projectProcessAudit'
      }
    }
  ]
}]